import _defineProperty from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { HTMLElement, h, Host, proxyCustomElement } from '@stencil/core/internal/client';
import { b as getIonMode } from './ionic-global.js';
var itemGroupIosCss = "ion-item-group{display:block}";
var itemGroupMdCss = "ion-item-group{display:block}";

var ItemGroup = /*#__PURE__*/function (_HTMLElement) {
  _inherits(ItemGroup, _HTMLElement);

  var _super = _createSuper(ItemGroup);

  function ItemGroup() {
    var _this;

    _classCallCheck(this, ItemGroup);

    _this = _super.call(this);

    _this.__registerHost();

    return _this;
  }

  _createClass(ItemGroup, [{
    key: "render",
    value: function render() {
      var _class;

      var mode = getIonMode(this);
      return h(Host, {
        role: "group",
        class: (_class = {}, _defineProperty(_class, mode, true), _defineProperty(_class, "item-group-".concat(mode), true), _defineProperty(_class, 'item', true), _class)
      });
    }
  }], [{
    key: "style",
    get: function get() {
      return {
        ios: itemGroupIosCss,
        md: itemGroupMdCss
      };
    }
  }]);

  return ItemGroup;
}(HTMLElement);

ItemGroup = /*@__PURE__*/proxyCustomElement(ItemGroup, [32, "ion-item-group"]);

function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }

  var components = ["ion-item-group"];
  components.forEach(function (tagName) {
    switch (tagName) {
      case "ion-item-group":
        if (!customElements.get(tagName)) {
          customElements.define(tagName, ItemGroup);
        }

        break;
    }
  });
}

var IonItemGroup = ItemGroup;
var defineCustomElement = defineCustomElement$1;
export { IonItemGroup, defineCustomElement };